import React, { useState, useEffect } from "react";
import CommonAreasEddit from './commonAreasEddit'
import AreasSchedule from './AreasSchedule';
import SuperCore from "../../components/core/SuperCore";
import ModalBorrar from '../modals/modalDelete';
import cogoToast from "cogo-toast";
import Request from "../../core/httpClient";
import BlackoutDates from './blackoutDates';
import DinamicModal from '../../components/dinamicModal/dinamicModal';

const request = new Request();

// Mismo parse robusto que usa el edit: devuelve los ids seleccionados como strings.
const parseSeleccionados = (raw) => {
  let seleccionados = [];
  if (Array.isArray(raw)) {
    seleccionados = raw;
  } else if (typeof raw === "string") {
    try {
      seleccionados = JSON.parse(raw);
    } catch (e) {
      seleccionados = [];
    }
  }
  if (!Array.isArray(seleccionados)) {
    return [];
  }
  return seleccionados
    .filter((sub) => Number(sub.selected) === 1)
    .map((sub) => sub.id_subfraccionamiento.toString());
};

const CommonAreaTable = (props) => {
  const [dataArea, setDataArea] = useState([]);
  const [idCommon, setIdCommon] = useState("");
  const [idEspacio, setIdEspacio] = useState(0);
  const [horarios, setHorarios] = useState([]);
  const [idMenuActivo, setIdMenuActivo] = useState(null);

  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [idSubfrac, setIdSubfrac] = useState(null);
  // Variable separada para los checkboxes; idSubfrac se manda tal cual.
  const [subfraccionamientosSeleccionados, setSubfraccionamientosSeleccionados] = useState([]);
  const [diasPrevios, setDiasPrevios] = useState(0);
  const [minutosPrevios, setMinutosPrevios] = useState(0);

  const [diasMax, setDiasMax] = useState("");
  const [horasMax, setHorasMax] = useState("");
  const [tiempoDisponible, setTiempoDisponible] = useState("");
  const [isDiasDisponible, setIsDiasDisponible] = useState(true);

  const [consecutivas, setConsecutivas] = useState(0);
  const [aforoMax, setAforoMax] = useState(false);
  const [aforo, setAforo] = useState(1);
  const [maXVivienda, setMaXVivienda] = useState(1);
  const [categoria, setCategoria] = useState(0);
  const [fianza, setFianza] = useState(0);
  const [pausar, setPausar] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [activo, setActivo] = useState(false);
  const [anuales, setAnuales] = useState("");
  const [mensuales, setMensuales] = useState("");
  const [diarias, setDiarias] = useState("");
  const [imagenArea, setImagenArea] = useState("");

  const [screenDefinition, setScreenDefinition] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowType, setRowType] = useState("");
  const [idEspacioRow, setIdEspacioRow] = useState(0);

  // Contador que fuerza el remonte del formulario de edición en cada apertura.
  const [openKey, setOpenKey] = useState(0);


  useEffect(() => {
    if (idCommon) {
      getSchedules(idCommon);
      setMenu(0);

    }
  }, [idCommon]);

  // Equivalente a componentDidUpdate para idEspacio
  useEffect(() => {
    if (idEspacio) {
      setMenu(0);

    }
  }, [idEspacio]);

  const reload = () => {
    props.reload();
  };




  const openRow = (type, idCommon) => {
    setIdCommon(idCommon);
    setIdEspacio(idCommon);

    // si ya estaba abierto, lo cerramos
    if (idCommon === idCommon && type === rowType) {
      setRowType("");
      setIdCommon(0);
      return;
    }

    setRowType(type);
  };

  const openModalDelete = (data, id_espacio) => {
    setIdEspacio(id_espacio);

    const modal = document.getElementById("deleteModal");
    if (modal) {
      modal.classList.remove("hide-modal");
      modal.classList.add("show-modal");
    }
  };

  const closeModal = (idModal) => {
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.remove("show-dinamic-modal");
      modal.classList.add("hide-dinamic-modal");
    }
  };


  // Función que antes estaba en SuperCore
  const getUserInfo = async () => {
    const iGateAdmin = JSON.parse(localStorage.getItem("iGateAdmin"));
    const response = await request.post("/admin/administracion/get/decodetoken", {
      token: iGateAdmin.id,
    });
    return response;
  };
  const handleDelete = async (id, close) => {
    try {
      const user = await getUserInfo(); // asegúrate de tener esta función importada o definida
      const usuario = user.info;

      const data = {
        id_espacio: id,
        id_usuario: usuario.id_usuario,
      };

      const res = await request.post("/commonArea/delete/area", data);

      if (res.deleted) {
        cogoToast.success("Área eliminada.", { position: "bottom-right" });
        props.reload();
      } else {
        cogoToast.error(res.message || "Error al eliminar área.", { position: "bottom-right" });
      }

      close();
    } catch (error) {
      console.error(error);
    }
  };

  const getMoneyFormat = (number) =>
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    }).format(number);

  const openModal = async (idModal, data) => {
    setDataArea(data);
    setIdEspacio(data.id_espacio);
    setIdCommon(0);

    setNombre(data.nombre);
    // idSubfrac se mantiene INTACTO con su valor original.
    setIdSubfrac(data.id_subfraccionamiento);
    // Los checkboxes marcados van en su propia variable.
    setSubfraccionamientosSeleccionados(parseSeleccionados(data.subfraccionamientosSeleccionados));
    setCategoria(data.id_categoria);
    setDiasPrevios(data.dias_reserva);
    setFianza(data.fianza);
    setMinutosPrevios(data.minutos_previos_reserva);
    setImagenArea(data.area_imagen || "");

    setDiasMax(data.dias_maximos_reserva || "");
    setHorasMax(data.horas_maximas_reserva || "");
    setTiempoDisponible(
      data.dias_maximos_reserva ? data.dias_maximos_reserva : data.horas_maximas_reserva
    );
    setIsDiasDisponible(!!data.dias_maximos_reserva);

    setAnuales(data.max_reservas_anual);
    setMensuales(data.max_reservas_mensual);
    setDiarias(data.max_reservas_diaria);
    setConsecutivas(data.max_reservas_consecutivas);
    setAforoMax(data.max_aforo !== null);
    setAforo(data.max_aforo || 1);
    setMaXVivienda(data.max_reservas_aforo || 1);
    setPausar(data.pausar);
    setMotivo(data.motivo || "");
    setActivo(data.activo);
    setDescripcion(data.descripcion);

    // fuerzoo que  CommonAreasEddit se remonte fresco en cada apertura.
    setOpenKey((k) => k + 1);

    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.remove("hide-dinamic-modal");
      modal.classList.add("show-dinamic-modal");
    }
  };

  const getSchedules = async (idCommon) => {
    try {
      const response = await request.post("/commonArea/get/schedule", { id: idCommon });
      if (response.commonSchedules && !response.empty) {
        response.commonSchedules.forEach((row) => {
          let dias = [];
          if (row.bloqueos) {
            const bloqueos = JSON.parse(row.bloqueos);
            for (let i = 1; i < 8; i++) {
              const exist = bloqueos.some((day) => day.dia === i);
              dias.push({ dia: i, status: exist });
            }
          } else {
            for (let i = 1; i < 8; i++) {
              dias.push({ dia: i, status: false });
            }
          }
          row.bloqueos = dias;
        });
        setHorarios(response.commonSchedules);
      } else {
        setHorarios([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setMenu = async (id) => {
    setIdMenuActivo(null);
    setIdMenuActivo(id);
  };



  const updateData = (json) => {
    Object.entries(json).forEach(([key, value]) => {
      switch (key) {
        case "nombre":
          setNombre(value);
          break;
        case "descripcion":
          setDescripcion(value);
          break;
        case "activo":
          setActivo(value);
          break;
        case "idSubfrac":
          setIdSubfrac(value);
          break;
        case "subfraccionamientosSeleccionados":
          setSubfraccionamientosSeleccionados(value);
          break;
        case "categoria":
          setCategoria(value);
          break;
        case "fianza":
          setFianza(value);
          break;
        case "diasPrevios":
          setDiasPrevios(value);
          break;
        case "minutosPrevios":
          setMinutosPrevios(value);
          break;
        case "imagenArea":
          setImagenArea(value);
          break;
        case "tiempoDisponible":
          setTiempoDisponible(value);
          break;
        case "isDiasDisponible":
          setIsDiasDisponible(value);
          break;
        case "anuales":
          setAnuales(value);
          break;
        case "mensuales":
          setMensuales(value);
          break;
        case "diarias":
          setDiarias(value);
          break;
        case "consecutivas":
          setConsecutivas(value);
          break;
        case "aforo":
          setAforo(value);
          break;
        case "aforoMax":
          setAforoMax(value);
          break;
        case "maXVivienda":
          setMaXVivienda(value);
          break;
        case "pausar":
          setPausar(value);
          break;
        case "motivo":
          setMotivo(value);
          break;
        default:
          break;
      }
    });
  };


  const handleSubmit = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault(); // por si el modal dispara un submit
    }

    try {
      setLoading(true);

      if (nombre === "") {
        cogoToast.warn("Es necesario añadir nombre antes de guardar.", { position: "bottom-right" });
        setLoading(false);
        return;
      }

      if (aforoMax && maXVivienda > aforo) {
        cogoToast.warn(
          "El número máximo por vivienda no puede ser mayor al número de aforo máximo.",
          { position: "bottom-right" }
        );
        setLoading(false);
        return;
      }

      // Nos aseguramos de mandar siempre un array de checkboxes seleccionados.
      const seleccionados = Array.isArray(subfraccionamientosSeleccionados)
        ? subfraccionamientosSeleccionados
        : [];

      const data = {
        nombre,
        descripcion,
        activo: activo ? 1 : 0,
        id: idEspacio,
        categoria: parseInt(categoria),
        diasR: parseInt(diasPrevios),
        minutosPrevios: parseInt(minutosPrevios),
        fianza: parseInt(fianza),
        diasMax: isDiasDisponible ? parseInt(tiempoDisponible) : null,
        horasMax: isDiasDisponible ? null : parseInt(tiempoDisponible),
        imagen: imagenArea,

        idSubfrac,

        subfraccionamientosSeleccionados: seleccionados,
        anuales: anuales ? parseInt(anuales) : null,
        mensuales: mensuales ? parseInt(mensuales) : null,
        diarias: diarias ? parseInt(diarias) : null,
        consecutivas: consecutivas ? parseInt(consecutivas) : null,
        aforo: aforoMax ? parseInt(aforo) : null,
        reservasAforoMax: aforoMax ? parseInt(maXVivienda) : null,
        pausar: pausar ? 1 : 0,
        motivo,
        idFrac: localStorage.getItem("frac") || 0,
      };
      debugger;
      const response = await request.post("/commonArea/update/common", data);

      if (response.updated) {
        cogoToast.success("Datos de área común actualizados.", { position: "bottom-right" });
        props.reload();
        closeModal("editCommon"); // cerrar modal igual que antes
      } else {
        cogoToast.error("No se pudo editar área común.", { position: "bottom-right" });
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };


  return (
    <div className="tw-bg-white tw-shadow tw-rounded-lg tw-p-4">
      {/* Contenedor con scroll vertical */}
      <div className="tw-overflow-x-auto tw-max-h-[500px] tw-overflow-y-auto">
        <table className="tw-min-w-full tw-border-collapse">
          <thead className="tw-bg-gray-100 tw-sticky tw-top-0">
            <tr className="tw-text-left tw-text-sm tw-font-semibold tw-text-gray-700">
              <th className="tw-px-4 tw-py-2 tw-align-middle">
                <div className="tw-flex tw-items-center tw-gap-1">
                  Categoría
                  <button
                    type="button"
                    onClick={() => props.sortBy("nombre_categoria")}
                    className="tw-ml-1 tw-text-gray-500 hover:tw-text-gray-700"
                  >
                    {props.filterColumn.col === "nombre_categoria" ? (
                      props.filterColumn.filt === "asc" ? (
                        <i className="fas fa-sort-up" />
                      ) : (
                        <i className="fas fa-sort-down" />
                      )
                    ) : (
                      <i className="fas fa-sort" />
                    )}
                  </button>
                </div>
              </th>
              {/* Nombre */}
              <th className="tw-px-4 tw-py-2 tw-align-middle">
                <div className="tw-flex tw-items-center tw-gap-1">
                  Nombre
                  <button
                    type="button"
                    onClick={() => props.sortBy("nombre")}
                    className="tw-ml-1 tw-text-gray-500 hover:tw-text-gray-700"
                  >
                    {props.filterColumn.col === "nombre" ? (
                      props.filterColumn.filt === "asc" ? (
                        <i className="fas fa-sort-up" />
                      ) : (
                        <i className="fas fa-sort-down" />
                      )
                    ) : (
                      <i className="fas fa-sort" />
                    )}
                  </button>
                </div>
              </th>

              {/* Fianza */}
              <th className="tw-px-4 tw-py-2 tw-align-middle">
                <div className="tw-flex tw-items-center tw-gap-1">
                  Fianza
                  <button
                    type="button"
                    onClick={() => props.sortBy("fianza")}
                    className="tw-ml-1 tw-text-gray-500 hover:tw-text-gray-700"
                  >
                    {props.filterColumn.col === "fianza" ? (
                      props.filterColumn.filt === "asc" ? (
                        <i className="fas fa-sort-up" />
                      ) : (
                        <i className="fas fa-sort-down" />
                      )
                    ) : (
                      <i className="fas fa-sort" />
                    )}
                  </button>
                </div>
              </th>

              {/* Estatus */}
              <th className="tw-px-4 tw-py-2 tw-align-middle">
                <div className="tw-flex tw-items-center tw-gap-1">
                  Estatus
                  <button
                    type="button"
                    onClick={() => props.sortBy("activo")}
                    className="tw-ml-1 tw-text-gray-500 hover:tw-text-gray-700"
                  >
                    {props.filterColumn.col === "activo" ? (
                      props.filterColumn.filt === "asc" ? (
                        <i className="fas fa-sort-up" />
                      ) : (
                        <i className="fas fa-sort-down" />
                      )
                    ) : (
                      <i className="fas fa-sort" />
                    )}
                  </button>
                </div>
              </th>
              <th className="tw-px-4 tw-py-2 tw-text-center tw-align-middle">Editar</th>
              <th className="tw-px-4 tw-py-2 tw-text-center tw-align-middle">Horarios</th>
              <th className="tw-px-4 tw-py-2 tw-text-center tw-align-middle">Eliminar</th>
            </tr>
          </thead>
          <tbody className="tw-divide-y tw-divide-gray-200">
            {props.commonAreas &&
              props.commonAreas
                .slice((props.page - 1) * props.pageLength, props.page * props.pageLength)
                .map((area, key) => (
                  <React.Fragment key={key}>
                    <tr
                      className={`tw-text-sm ${idEspacioRow === area.id_espacio ? "tw-bg-gray-50" : ""}`}
                    >
                      <td className="tw-px-4 tw-py-0.2 tw-align-middle">{area.nombre_categoria}</td>
                      <td className="tw-px-4 tw-py-0.2 tw-align-middle">{area.nombre}</td>
                      <td className="tw-px-4 tw-py-0.2 tw-align-middle">
                        {area.fianza ? getMoneyFormat(area.fianza) : "0.00"}
                      </td>
                      <td className="tw-px-4 tw-py-0.2 tw-align-middle">
                        {area.activo === 1 ? "Activo" : "Inactivo"}
                      </td>
                      <td className="tw-px-4 tw-py-0.2 tw-text-center tw-align-middle">
                        <button
                          type="button"
                          onClick={() => openModal("editCommon", area)}
                          className="btn-purple tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5"
                        >
                          <i className="fas fa-pen tw-text-xs" />
                        </button>
                      </td>
                      <td className="tw-px-4 tw-py-0.5 tw-text-center tw-align-middle">
                        <button
                          type="button"
                          onClick={() => openRow("newSchedule", area.id_espacio)}
                          className="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded tw-bg-gray-500 tw-text-white hover:tw-bg-indigo-400"
                        >
                          <i className="fas fa-clock tw-text-xs" />
                        </button>
                      </td>
                      <td className="tw-px-4 tw-py-0.2 tw-text-center tw-align-middle">
                        <button
                          type="button"
                          onClick={() => openModalDelete("deleteCommon", area.id_espacio)}
                          className="btn-red tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6"
                        >
                          <i className="fas fa-trash-alt tw-text-xs" />
                        </button>
                      </td>
                    </tr>
                    {idCommon === area.id_espacio && (
                      <tr>
                        <td colSpan="7" className="tw-bg-gray-50 tw-px-4 tw-py-0.2 tw-align-middle">
                          <AreasSchedule
                            id={area.id_espacio}
                            horarios={horarios}
                            getSchedules={getSchedules}
                            escritura={props.escritura}
                          />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
          </tbody>
        </table>
      </div>


      {/* Modal de edición */}
      <DinamicModal
        idModal={"editCommon"}
        sizeModalContainer="big"
        title={"Editar área común"}
        success={handleSubmit}
        showBtnSuccess={props.escritura}
        btnTextSuccess={"ACTUALIZAR"}
        showBtnCancel={true}
        btnTextCancel={"CANCELAR"}
        loadingSave={loading}
        message={""}
        closeModal={() => closeModal("editCommon")}
      >
        <CommonAreasEddit
          key={`edit-${dataArea.id_espacio}-${openKey}`}
          subfraccionamientos={props.subfraccionamientos}
          area={dataArea}
          reload={reload}
          escritura={props.escritura}
          subLabel={props.subLabel}
          updateData={(json) => updateData(json)}
        />
        <BlackoutDates idEspacio={dataArea.id_espacio}></BlackoutDates>
      </DinamicModal>

      {/* Modal de eliminación */}
      <ModalBorrar id={idEspacio} delete={handleDelete} message={"¿Estás seguro que deseas eliminar el área común?"} />
    </div >
  );




};

export default CommonAreaTable;
